import {CanActivateFn, CanLoad, CanLoadFn, CanMatchFn, Router} from '@angular/router';
import {AuthService} from "./Auth.service";
import {inject} from "@angular/core";
import {RoleEnum} from "../../modules/enums/roleEnum";

export const roleGuard: CanActivateFn | CanMatchFn = (route: { data: { [x: string]: any; }; }) => {
  const router = inject(Router);
  const auth = inject(AuthService);

  if (!auth.isAuthenticated()) return router.parseUrl('/login');

  const role = auth.getRole();
  const requiredRoles = route.data['roles'];
  if (requiredRoles && !requiredRoles.includes(role!)) return router.parseUrl('/access-denied');

  // A route may declare the exact permission its endpoints require. That is stricter
  // than the group and is checked for every role, so a page whose API would 403 is
  // not reachable at all. Routes without one keep the group check below.
  const permission = route.data['permission'];
  if (permission && !auth.hasAdminPermission(permission)) {
    return router.parseUrl('/access-denied');
  }

  // A page serving several endpoints with different permissions opens for any one of them.
  const anyPermission: readonly string[] | undefined = route.data['anyPermission'];
  if (anyPermission && !auth.hasAnyAdminPermission(anyPermission)) {
    return router.parseUrl('/access-denied');
  }

  // SubAdmin access is further scoped by permission group, mirroring the sidenav's visibility rules.
  // Routes without a declared permissionGroup keep the role-only check above.
  const permissionGroup = route.data['permissionGroup'];
  if (!permission && !anyPermission && role === RoleEnum.SubAdmin && permissionGroup && !auth.hasPermissionGroup(permissionGroup)) {
    return router.parseUrl('/access-denied');
  }

  return true;
};


